import { matchingAtom } from "Global/Components/CommonComponents/GroupedView/shared/MatchingFields";
import { useAtom } from "jotai";
import React, { useEffect, useState } from "react";

const useSetRadioFormValue = (element, setValue, initialValue) => {
  const [matchigFields] = useAtom(matchingAtom);
  const [value, setVal] = useState("");
  const [children, setChildren] = useState([]);
  const MatchingIndex = matchigFields?.findIndex(
    (obj) =>
      element.filter((fl) => fl.name === value)[0]?.iddetail === obj.iddetail
  );
  const unMatchingIndex = matchigFields?.findIndex(
    (obj) =>
      element.filter((fl) => fl.name !== value)[0]?.iddetail === obj.iddetail
  );
  const childs = element.filter((fl) => fl.name === value)[0]?.Children;
  const handleChange = (event) => {
    setVal(event.target.value);
  };
  useEffect(() => {
    for (let i = 0; i < initialValue.length; i++) {
      if (Number(initialValue[i].value) === 1) {
        setVal(initialValue[i].name);
      }
    }
  }, [initialValue]);
  useEffect(() => {
    if (value) {
      setValue(`MedicalDefaultValues[${MatchingIndex}].value`, Number(1));
      setValue(`MedicalDefaultValues[${unMatchingIndex}].value`, "");
      if (childs?.length > 0) {
        setChildren(childs);
      } else {
        setChildren([]);
      }
    }
  }, [value, parent]);
  return { handleChange, value, children };
};

export default useSetRadioFormValue;
